import IVolumeStore from '../../../State/Stores/Volume/Interfaces/IVolumeStore';
import Volume       from '../../../State/Stores/Volume/Volume';
import ISolution    from '../Interfaces/ISolution';

const subscribeToVolume = (volumeStore: IVolumeStore, solution: ISolution) =>
    volumeStore.update$
        .subscribe((nextVolume: Volume) => solution.volume(nextVolume.level));

export default subscribeToVolume;